import Icon from '../../components/Icon'

Icon.register({
  'regular/eye': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 144c0.1 0 0.2 0 0.4 0 61.7 0 111.7 50.1 111.7 111.7s-50.1 111.7-111.7 111.7-111.7-50.1-111.7-111.7c0-10.7 1.5-21.1 4.4-31 8 4.5 17.2 7.2 27 7.2 30.9 0 56-25.1 56-56-0.1-9.8-2.7-19-7.2-27 9.9-3.1 20.4-4.8 31.2-5zM572.5 241.4c2.2 4.4 3.5 9.4 3.5 14.6 0 5.2-1.2 10.2-3.5 14.6-54.2 105.8-161.6 177.4-284.5 177.4s-230.3-71.6-284.5-177.4c-2.2-4.4-3.5-9.4-3.5-14.6 0-5.2 1.2-10.2 3.5-14.6 54.2-105.8 161.6-177.4 284.5-177.4s230.3 71.6 284.5 177.4zM288 400c98.7 0 189.1-55 237.9-144-48.8-89-139.3-144-237.9-144s-189.1 55-237.9 144c48.8 89 139.3 144 237.9 144z'
      }
    ]
  }
})
